import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getImageUrl } from "src/Common/common";
import ConfirmDialog from "src/Common/confirmdialog";
import { getAssignedTechsNameArray, handleError, isAdmin, isManagerOver } from "src/Common/function";
import LoadMoreButton from "src/Components/Common/loadmorebutton";
import { setWONumber } from "src/Redux/Slices/HeaderSlice";
import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";
import WOStatusComponent from "./Status/wostatuscomponent";
import WoType from "src/Pages/WO/Components/Types/WoType";
import { priorityLevels } from "src/Common/contants";
import Highlight from "src/Components/Common/Highlight";

function WoTable({ data, keyword, branch, loadMore, loadMoreButtonShown, deleteSuccess, sort }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentUser] = useState(UserService.getCurrentUser());
  const [woArray, setWOArray] = useState([]);
  const [isDeleteConfirmDialogShown, setIsDeleteConfirmDialogShown] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState(0);

  //sorting
  const [sortByStartDate, setSortByStartDate] = useState(-1);
  const [sortByNumber, setSortByNumber] = useState(-1);

  useEffect(() => {
    let woData = _.cloneDeep(data);
    for (let i = 0; i < woData.length; i++) {
      woData[i].techNames = getAssignedTechsNameArray(woData[i].assignedTechs);
    }
    setWOArray(woData);
  }, [data]);

  const deleteWorkOrder = () => {
    WOService.deleteById(woArray[indexToDelete].id)
      .then((response) => {
        console.log("delete res: ", response);
        if (response.status == 200) {
          setIsDeleteConfirmDialogShown(false);
          deleteSuccess(indexToDelete);
          toast("Work order deleted successfully");
        }
      })
      .catch((error) => {
        setIsDeleteConfirmDialogShown(false);
        handleError(error);
      });
  };

  return (
    <>
      <ConfirmDialog
        title="DELETE WORK ORDER"
        description="Are you sure you want to delete this?"
        shown={isDeleteConfirmDialogShown}
        onConfirmClicked={deleteWorkOrder}
        onCancelClicked={() => setIsDeleteConfirmDialogShown(false)}
      />
      <div
        className="w-full flex-1 min-h-0 flex flex-col overflow-hidden"
        style={{
          borderRadius: "12px",
          border: "1px solid #E5E8F3",
          background: "#FFF",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.00), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
          <table className="w-full">
            <thead className="sticky top-0 z-10">
              <tr
                style={{ borderBottom: "1px solid #E5E8F3", background: "#F8F9FE" }}
                className="[&>th]:border-r [&>th]:border-borderColor [&>th:last-child]:border-r-0"
              >
                <th
                  className="cursor-pointer"
                  onClick={() => {
                    if (sortByNumber === 1 || sortByNumber === -1) {
                      setSortByNumber(0);
                      sort({ number: 0 });
                    } else if (sortByNumber === 0) {
                      setSortByNumber(1);
                      sort({ number: 1 });
                    }
                    setSortByStartDate(-1);
                  }}
                >
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center justify-center gap-1 pl-4 w-[100px] h-[44px] text-[#5F6477] text-center">
                    <span>WO#</span>
                    {sortByNumber === 0 ? <IoIosArrowRoundUp /> : sortByNumber === 1 ? <IoIosArrowRoundDown /> : null}
                  </div>
                </th>
                <th>
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center justify-center w-[120px] h-[44px] text-[#5F6477]">
                    Type
                  </div>
                </th>
                <th>
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[200px] h-[44px] text-[#5F6477]">
                    Customer
                  </div>
                </th>
                <th>
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center w-[60px] h-[44px] text-[#5F6477] justify-center">
                    NTE
                  </div>
                </th>
                <th className="w-full">
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 h-[44px] text-[#5F6477]">
                    Description
                  </div>
                </th>
                <th
                  onClick={() => {
                    if (sortByStartDate === 1 || sortByStartDate === -1) {
                      setSortByStartDate(0);
                      sort({ date: 0 });
                    } else if (sortByStartDate === 0) {
                      setSortByStartDate(1);
                      sort({ date: 1 });
                    }
                    setSortByNumber(-1);
                  }}
                  className="cursor-pointer"
                >
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center justify-center gap-1 w-[140px] h-[44px] text-[#5F6477]">
                    <span>Date Started</span>
                    {sortByStartDate === 0 ? (
                      <IoIosArrowRoundUp />
                    ) : sortByStartDate === 1 ? (
                      <IoIosArrowRoundDown />
                    ) : null}
                  </div>
                </th>
                <th>
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[200px] h-[44px] text-[#5F6477]">
                    Technician
                  </div>
                </th>
                {branch === 0 && (
                  <th>
                    <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[120px] h-[44px] text-[#5F6477]">
                      Branch
                    </div>
                  </th>
                )}
                <th className="!border-r-0">
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[130px] h-[44px] text-[#5F6477]">
                    Status
                  </div>
                </th>
                <th>
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center pl-4 w-[20px] h-[44px] text-[#5F6477]"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              {woArray.map((order, index) => (
                <tr
                  key={index}
                  onClick={(event) => {
                    if (event.ctrlKey || event.metaKey) {
                      window.open("/work/" + String(order.id), "_blank");
                      return;
                    }
                    dispatch(setWONumber(String(order.number)));
                    navigate("/work/" + String(order.id));
                    // WOService.getWorkOrderById(order.id)
                    //   .then((response) => {
                    //     if (response.status == 200) {
                    //       navigate("/work/" + String(order.number), {
                    //         state: { order: response.data },
                    //       });
                    //     }
                    //   })
                    //   .catch((error) => handleError(error));
                  }}
                  className={`border-b border-borderColor cursor-pointer hover:bg-[#FAFAFB] [&>td]:border-r [&>td]:border-borderColor [&>td:last-child]:border-r-0 ${
                    order.status === 0 ? "bg-[#fdeaff]" : ""
                  }`}
                >
                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-center text-[13px] leading-[20px] font-[400] text-[#1A2332] col-span-1">
                      <Highlight text={order.number} keyword={keyword} />
                    </div>
                  </td>
                  <td>
                    <div className="mx-auto flex justify-center">
                      <WoType serviceType={order.serviceType} />
                    </div>
                  </td>
                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] font-[400] text-[#1A2332] word-break-break-word">
                      <Highlight text={order.customer?.companyName} keyword={keyword} />
                    </div>
                  </td>
                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] font-[400] text-[#1A2332] text-center">
                      {order.NTE}
                    </div>
                  </td>

                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] text-[#1A2332] text-ellipsis word-break-break-word">
                      <Highlight text={order.description} keyword={keyword} />
                    </div>
                  </td>
                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] text-[#1A2332] text-ellipsis text-center">
                      {order.startDateString && order.startDateString}
                    </div>
                  </td>
                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] text-[#1A2332] text-ellipsis">
                      <Highlight text={order.techNames} keyword={keyword} />
                    </div>
                  </td>
                  {branch === 0 && (
                    <td>
                      <div className="font-OpenSansRegular px-4 py-3 text-[13px] leading-[20px] font-[400] text-[#1A2332] word-break-break-word">
                        {order.branch?.name || order.branch || ""}
                      </div>
                    </td>
                  )}
                  <td className="!border-r-0">
                    <div className="px-4 py-3 flex flex-col items-center gap-3">
                      <WOStatusComponent value={order.status} />
                      <div className="font-OpenSansRegular text-[13px] leading-[20px] text-[#1A2332] text-ellipsis word-break-break-word">
                        {priorityLevels[order.priorityLevel]}
                      </div>
                    </div>
                  </td>

                  <td>
                    {isAdmin() && (
                      <img
                        onClick={(event) => {
                          setIsDeleteConfirmDialogShown(!isDeleteConfirmDialogShown);
                          setIndexToDelete(index);
                          event.stopPropagation();
                        }}
                        src={getImageUrl("/images/common/trash.png")}
                        className="cursor-pointer"
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {loadMoreButtonShown && (
            <div className="w-full mt-[10px] mb-[10px] flex justify-center">
              <LoadMoreButton onClicked={loadMore} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default WoTable;
